import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
const DISMISS_KEY = "pos.broadcast.dismissed";
export function BroadcastBanner({ api }) {
    const [list, setList] = useState([]);
    const [dismissed, setDismissed] = useState(() => {
        try {
            return new Set(JSON.parse(sessionStorage.getItem(DISMISS_KEY) ?? "[]"));
        }
        catch {
            return new Set();
        }
    });
    useEffect(() => {
        let alive = true;
        const tick = () => api("/api/server/broadcasts").then((d) => alive && setList(d)).catch(() => { });
        tick();
        const t = setInterval(tick, 30_000);
        return () => { alive = false; clearInterval(t); };
    }, []); // eslint-disable-line
    const visible = list.filter((b) => !dismissed.has(b.id));
    if (visible.length === 0)
        return null;
    const dismiss = (id) => {
        const next = new Set(dismissed);
        next.add(id);
        setDismissed(next);
        sessionStorage.setItem(DISMISS_KEY, JSON.stringify([...next]));
    };
    const colors = {
        info: "bg-blue-50 border-blue-300 text-blue-900",
        warn: "bg-orange-50 border-orange-300 text-orange-900",
        urgent: "bg-red-50 border-red-300 text-red-900",
    };
    return (_jsx("div", { className: "space-y-2 mb-3", children: visible.map((b) => (_jsxs("div", { className: `px-4 py-2 border-2 rounded text-sm flex items-start justify-between gap-3 ${colors[b.level] ?? colors.info}`, children: [_jsxs("div", { children: [_jsx("span", { className: "text-[10px] uppercase tracking-wider font-semibold mr-2", children: b.level === "urgent" ? "URGENTE" : b.level === "warn" ? "AVISO" : "INFO" }), b.message] }), _jsx("button", { onClick: () => dismiss(b.id), className: "text-current opacity-60 hover:opacity-100", children: "\u2715" })] }, b.id))) }));
}
